import {
	createRouter,
	useRoute,
	useRouter,
	type RouteRecordRaw,
	type RouterOptions,
} from "vue-router";
import type { RootRoute, Route } from "./route";

export function createRoutes(root: RootRoute) {
	root.init();

	function makeRoute(route: Route): RouteRecordRaw {
		return {
			...route.options,
			name: route.name,
			children: Array.isArray(route.options.children)
				? route.options.children.map((r) => makeRoute(r))
				: undefined,
		} as any;
	}
	const routes: RouteRecordRaw[] = [makeRoute(root)];

	return routes;
}

export type TypedRouterOptions = Omit<RouterOptions, "routes">;

export function createTypedRouter(options: TypedRouterOptions, root: RootRoute) {
	const routes = createRoutes(root);

	const router = createRouter({
		...options,
		routes,
	});

	return {
		router,

		/**
		 * @deprecated use `useRouter` instead
		 */
		useTypedRouter() {
			const router = useRouter();
			return router;
		},

		/**
		 * @deprecated use `useRoute` instead
		 */
		useTypedRoute() {
			const route = useRoute();

			return route;
		},
	};
}
